import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DocumentGroupService } from 'src/app/Service/DocumentGroup/DocumentGroup.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DocumentGroupEdit',
  templateUrl: './DocumentGroupEdit.component.html',
  styleUrls: ['./DocumentGroupEdit.component.scss']
})
export class DocumentGroupEditComponent implements OnInit {
  EditRecord:Number

  constructor(
    private DocumentGroup_Service:DocumentGroupService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.EditDocumentGroup=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    

    this.Nav_Service.CheckValidPage(28).subscribe(
      data=>{
        this.DocumentGroup_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
    
          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

    //#region  Form Add

    EditDocumentGroup:FormGroup;

    get_Form_Id(){
      return this.EditDocumentGroup.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditDocumentGroup.get('Title') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditDocumentGroup(){
      var Record:General_Interface =Empty_General_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      this.InProccessing=true
      this.DocumentGroup_Service.EditDocumentGroup(Record).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else{

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }
      )
    }



}
